export default class Service {
    private readonly _language: string;
    private readonly _name: string;
    private readonly _size: number;
    private readonly _sizeUnit: string;
    private readonly _type: string;
    constructor({
        language,
        name,
        size,
        sizeUnit,
        type,
        details
    }) {
        this._language = language;
        this._name = name;
        this._size = size;
        this._sizeUnit = sizeUnit;
        this._type = type;
    }

    get language(): string {
        return this._language;
    }

    get name(): string {
        return this._name;
    }

    get size(): number {
        return this._size;
    }

    get sizeUnit(): string {
        return this._sizeUnit;
    }

    get type(): string {
        return this._type;
    }
}
